type InputType = 'from' | 'to'

interface SplitDecimalResult {
  first: string
  last: string
}

/**
 * Принимает строку (число, целое или дробное) и флаг ('from'/'to').
 * Возвращает объект { first, last } — часть до точки и после точки.
 * Если точка отсутствует:
 *  - 'from' => last = '00'
 *  - 'to'   => last = '00000000'
 */
export function splitDecimal(
  value: string,
  input: InputType,
): SplitDecimalResult {
  // Проверяем, есть ли точка в строке
  const r = String(parseFloat(value))

  const hasDot = r.includes('.')

  if (hasDot) {
    // Разбиваем по точке
    const [first, last] = value.split('.')
    return { first, last }
  } else {
    // Нет точки => целое число
    const first = String(parseFloat(value))
    const last = input === 'from' ? '00' : '00000000'

    return { first, last }
  }
}
